module.exports = __webpack_public_path__ + "static/media/banner-tech.119dbd29.png";